import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 7q 4.5 -3 9 0t 9 0","key":"svg-0"}],["path",{"d":"M3 17q 4.5 -3 9 0q .213 .142 .427 .27","key":"svg-1"}],["path",{"d":"M3 12q 4.5 -3 9 0q 2.006 1.338 4.012 1.482","key":"svg-2"}],["path",{"d":"M19 16v6","key":"svg-3"}],["path",{"d":"M22 19l-3 3l-3 -3","key":"svg-4"}]]

const IconRippleDown = createReactComponent('outline', 'ripple-down', 'RippleDown', __iconNode);

export default IconRippleDown;